module.exports = __webpack_public_path__ + "img/chevron-up.cc733da1.svg";